import {
  Component,
  TemplateRef,
  ChangeDetectionStrategy,
  input,
  viewChild,
  output,
} from '@angular/core';
import {
  IQueueItem,
  Ag1QueueItemComponent,
} from '../ag1-queue-item/ag1-queue-item.component';
import { Popover } from '@openng/optimus-ui/popover';
import { Bind } from '@openng/optimus-ui/bind';
import { Button } from '@openng/optimus-ui/button';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { Tooltip } from '@openng/optimus-ui/tooltip';
import { NgTemplateOutlet } from '@angular/common';

export interface IQueueMenuAction {
  index: number;
  value: any;
}
@Component({
  selector: 'ag1-queue-menu',
  templateUrl: './ag1-queue-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    Bind,
    Button,
    AngularSvgIconModule,
    Popover,
    Tooltip,
    NgTemplateOutlet,
    Ag1QueueItemComponent,
  ],
})
export class Ag1QueueMenuComponent {
  /** (Required) The queue menu items to display in the queue menu.
   * Example of a queue item:
   * {
      id: '1',
      title: 'Queue Item 1',
      subTitle: 'Queue Item 1 Subtitle',
      state: 'loading',
      leadingIcon: {
        iconUrl: 'assets/icons/general/document-no-text.svg',
        color: 'text-steel-blue-500',
      },
      action: {
        label: 'link',
      },
    },
  */
  readonly queueItems = input<IQueueItem[]>([]);

  /** (Optional) The title to display in the queue menu. */
  readonly title = input<string>('Title');

  /** (Optional) The template to display a custom empty state in the queue menu. */
  readonly customEmptyStateTemplateRef = input<TemplateRef<any>>(undefined);

  /** (Optional) Whether the queue menu trigger is disabled or not. */
  readonly disabled = input<boolean>(false);

  /** (Optional) The event to emit when the menu is opened. */
  readonly menuOpenEvent = output<void>();

  /** (Optional) The event to emit when the menu is closed. */
  readonly menuCloseEvent = output<void>();

  /** (Optional) The event to emit when an item is clicked in the queue menu. */
  readonly itemClickEvent = output<IQueueItem>();

  isActive: boolean = false;

  readonly queueMenuPopover = viewChild.required<Popover>('queueMenuPopover');

  constructor() {}

  onMenuClose(): void {
    this.isActive = false;
  }

  onMenuOpen(event: Event): void {
    this._openMenu(event);
    this.isActive = true;
    this.menuOpenEvent.emit();
  }

  onCloseQueueMenu(): void {
    this._closeMenu();
    this.isActive = false;
    this.menuCloseEvent.emit();
  }

  onItemClick(item: IQueueItem): void {
    this.itemClickEvent.emit(item);
  }

  private _openMenu(event: Event): void {
    this.queueMenuPopover().toggle(event);
  }

  private _closeMenu(): void {
    this.queueMenuPopover().hide();
  }
}
